'use client'

import FloatingMenu from '@/components/global/FloatingMenu'
import Footer       from '@/components/global/Footer'
import Header       from '@/components/global/Header'

const SiteChrome = ({
	children,
	footer,
	header,
	floatingMenu,
}) => {
	return (<>
		<Header header={header}/>

		<FloatingMenu floatingMenu={floatingMenu}/>

		{children}

		<Footer
			data={footer}
			header={header}
		/>
	</>)
}

export default SiteChrome
